import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function Checkout() {
  const { streamId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // If someone navigates directly to /checkout, redirect to stream detail
    if (streamId) {
      navigate(`/stream/${streamId}`);
    } else {
      navigate('/');
    }
  }, [streamId, navigate]);

  return (
    <div className="loading">
      <div className="spinner"></div>
    </div>
  );
}
